import { definitions } from "../../common-fetch/generated/orders-model-api";
import { RecoilKeys } from "../../common/miscellaneous/RecoilKeys";
import { atom } from "../../common/miscellaneous/atom";

export const countryAdministrativeAreasAtom = atom<
  ReadonlyArray<definitions["IsoCountryResponse"]>
>({
  key: RecoilKeys.CountryAdministrativeAreas,
  default: [],
});
